import { application } from "./application"

import HelloController from "./hello_controller"
import CommentFormController from "./comment_form_controller"
import ZipLookupController from "./zip_lookup_controller"
import RoutesController from "./routes_controller"

application.register("hello", HelloController)
application.register("comment-form", CommentFormController)
application.register("zip-lookup", ZipLookupController)
application.register("routes", RoutesController)